/**
 * Fila de filtros por FACTURA de «Mis solicitudes de pago» (debajo de la fila de filtros de la
 * solicitud). Una solicitud aparece si ALGUNA de sus facturas (CFDIs vigentes o el invoice)
 * cumple TODOS los filtros de factura activos · el filtrado es en el servidor.
 */
export type FacturaFiltroKey = "uuid" | "serieFolio" | "emisor" | "fecha" | "total" | "moneda" | "indicador" | "numeroInvoice";

export type FiltrosFactura = Partial<Record<FacturaFiltroKey, string>>;

/** Campos de la fila, en orden · `param` es el query param del API (`/solicitudes/mias`). */
export const CAMPOS_FILTRO_FACTURA: {
  key: FacturaFiltroKey;
  label: string;
  placeholder: string;
  param: string;
  /**
   * Columnas CONSECUTIVAS de la tabla de solicitudes que ocupa el campo (sus `key`) · así sus
   * encabezados e inputs quedan alineados con los de la fila de filtros de arriba.
   */
  columnas: string[];
  fecha?: boolean;
}[] = [
  { key: "uuid", label: "UUID", placeholder: "77B68ED3-BD86-479F-814A-022541C813FD", param: "facturaUuid", columnas: ["folio", "estado"] },
  { key: "serieFolio", label: "Serie-folio", placeholder: "FG-1559", param: "facturaSerieFolio", columnas: ["organizacion"] },
  { key: "emisor", label: "Emisor / RFC", placeholder: "GPS120130S8A", param: "facturaEmisor", columnas: ["tipo", "caOc"] },
  { key: "total", label: "Total", placeholder: "2449.92", param: "facturaTotal", columnas: ["total"] },
  { key: "moneda", label: "Moneda", placeholder: "MXN", param: "facturaMoneda", columnas: ["area"] },
  { key: "indicador", label: "Indicador", placeholder: "V5", param: "facturaIndicador", columnas: ["descripcion"] },
  { key: "numeroInvoice", label: "Núm. factura Invoice", placeholder: "952645620661MDS", param: "facturaNumeroInvoice", columnas: ["proveedor"] },
  { key: "fecha", label: "Fecha timbrado", placeholder: "09/09/2026", param: "facturaFecha", columnas: ["fechaPago"], fecha: true },
];

/** Solo los filtros con texto (recortado). */
export function filtrosFacturaNoVacios(f: FiltrosFactura): FiltrosFactura {
  const out: FiltrosFactura = {};
  for (const { key } of CAMPOS_FILTRO_FACTURA) {
    const v = f[key]?.trim();
    if (v) out[key] = v;
  }
  return out;
}

/** Query params del API para los filtros de factura activos. */
export function paramsFiltrosFactura(f: FiltrosFactura | undefined): Record<string, string> {
  if (!f) return {};
  const activos = filtrosFacturaNoVacios(f);
  const out: Record<string, string> = {};
  for (const c of CAMPOS_FILTRO_FACTURA) {
    const v = activos[c.key];
    if (v) out[c.param] = v;
  }
  return out;
}

export function hayFiltrosFactura(f: FiltrosFactura): boolean {
  return Object.keys(filtrosFacturaNoVacios(f)).length > 0;
}

/** Placeholder de un filtro con valor de ejemplo REAL y completo · «p. ej. 2449.92». */
export function placeholderEjemplo(ejemplo: string): string {
  return `p. ej. ${ejemplo}`;
}
